export const ASSIGNEE_MENU_MIN_WIDTH = 290;

export const PRIORITY_ASSIGNEES = [
  "danielgraham@getupgraded.ca",
  "afeef@getupgraded.ca",
  "ben@getupgraded.ai",
  "daksh@getupgraded.ca",
  "will@getupgraded.ca",
];

export const OPPORTUNITY_ASSIGNEES = [
  "james@getupgraded.ca",
  "will@getupgraded.ca",
  "nico@getupgraded.ca",
  "haris@getupgraded.ca",
  "ercan@getupgraded.ca",
  "emina@getupgraded.ca",
  "julia@getupgraded.ca",
  "giovanna@getupgraded.ca",
  "hamza@getupgraded.ca",
  "matthew@getupgraded.ca",
  "fatma@getupgraded.ca",
  "youssef@getupgraded.ca",
  "ankit@getupgraded.ca",
  "arbri@getupgraded.ca",
  "afeef@getupgraded.ca",
  "danielgraham@getupgraded.ca",
  "ben@getupgraded.ai",
  "daksh@getupgraded.ca",
  "shady@getupgraded.ca",
  "accounting@getupgraded.ca",
  "unassigned",
];

export const PERFECT_DRAFT_ASSIGNEES = [
  "dataengineering@getupgraded.ai",
  "donnie@getupgraded.ai",
  "isaac@getupgraded.ai",
  "jintai@getupgraded.ai",
  "will@getupgraded.ai",
];

export function mergeAssigneeLists(...lists) {
  const seen = new Set();
  const merged = [];

  for (const list of lists) {
    for (const raw of list) {
      const email = typeof raw === "string" ? raw.trim() : "";
      if (!email || seen.has(email)) continue;
      seen.add(email);
      merged.push(email);
    }
  }

  return merged;
}

export function collectFieldValuesFromOpportunities(
  opportunities = [],
  fieldNames = ["Assignee"]
) {
  const values = [];

  for (const opportunity of opportunities) {
    for (const fieldName of fieldNames) {
      const value = opportunity?.fields?.[fieldName];
      if (value?.trim()) {
        values.push(value.trim());
      }
    }
  }

  return values;
}

export function buildOpportunityAssigneeList(
  opportunities = [],
  baseAssignees = OPPORTUNITY_ASSIGNEES
) {
  return mergeAssigneeLists(
    baseAssignees,
    collectFieldValuesFromOpportunities(opportunities, ["Assignee"])
  );
}

export function buildPerfectDraftAssigneeList(
  opportunities = [],
  baseAssignees = PERFECT_DRAFT_ASSIGNEES
) {
  return mergeAssigneeLists(
    baseAssignees,
    collectFieldValuesFromOpportunities(opportunities, ["DataEngineerDrafter"])
  );
}

export function getAssigneeSelectGroups(
  assignees = OPPORTUNITY_ASSIGNEES,
  priorityAssignees = PRIORITY_ASSIGNEES
) {
  const prioritySet = new Set(priorityAssignees);
  const assigneeSet = new Set(assignees);

  return {
    priority: priorityAssignees.filter((email) => assigneeSet.has(email)),
    others: assignees.filter((email) => !prioritySet.has(email)),
  };
}

export function buildAssigneeSelectOptions(
  assignees = OPPORTUNITY_ASSIGNEES,
  { includeAllOption = false } = {}
) {
  const { priority, others } = getAssigneeSelectGroups(assignees);

  return [
    ...(includeAllOption
      ? [
          {
            label: "Filter",
            options: [{ value: "all", label: "All Assignees" }],
          },
        ]
      : []),
    ...(priority.length > 0
      ? [
          {
            label: "Primary",
            options: priority.map((email) => ({
              value: email,
              label: email,
            })),
          },
        ]
      : []),
    ...(others.length > 0
      ? [
          {
            label: "All assignees",
            options: others.map((email) => ({
              value: email,
              label: email,
            })),
          },
        ]
      : []),
  ];
}

export function buildPerfectDraftAssigneeSelectOptions(
  currentValue = "",
  defaults = PERFECT_DRAFT_ASSIGNEES
) {
  const seen = new Set(defaults);
  const options = defaults.map((email) => ({ value: email, label: email }));

  if (currentValue && !seen.has(currentValue)) {
    options.unshift({ value: currentValue, label: currentValue });
  }

  return options;
}
